import { withStyles } from '@material-ui/core/styles';
import GridListTile from '@material-ui/core/GridListTile';

export default withStyles(theme => ({
  tile: {
    backgroundColor: theme.palette.white.main,
    boxShadow: theme.customShadows[1],
  },
}))(GridListTile);
